/** @jsx jsx */
import * as React from 'react';
import { Fragment } from 'react';
import { jsx } from '@balance-web/core';

import { SiteHeader } from '../SiteHeader';
import { UserInfoContainer } from '../UserInfo/UserInfoContainer';
import { ReckonLogo } from '../../design-system/logos';

import { AppLayout } from './AppLayout';

export type AppLayoutContainerProps = {
  siteName: string;
} & Parameters<typeof UserInfoContainer>[0];

export const AppLayoutContainer: React.FC<React.PropsWithChildren<
  AppLayoutContainerProps
>> = ({ siteName, helpAndSupportUrl, children }) => {
  return (
    <AppLayout
      header={
        <SiteHeader
          logo={<ReckonLogo />}
          navigation={<Fragment />}
          user={<UserInfoContainer helpAndSupportUrl={helpAndSupportUrl} />}
        />
      }
    >
      {children}
    </AppLayout>
  );
};
